<template>
  <header class="template-header" data-testid="template-header">
    <HeadingDisplayLoader
      v-if="isLoading"
      class="template-header__loader"
      data-testid="template-header-loader"
    />
    <SectionError
      v-else-if="hasError"
      data-testid="template-header-error"
      title="Não foi possível carregar as informações dessa carteira"
      description="Aguarde alguns minutos e tente novamente."
      @on-retry="emitOnRetry"
    />
    <div v-else>
      <ChipContext
        v-if="data.isManagedByWarren"
        label="Gestão Warren"
        icon="G0010"
        context="brand"
        class="template-header__chip-context"
      />
      <HeadingDisplay
        :title="data.title"
        :subtitle="data.description"
        data-testid="template-header-content"
        size="medium"
      />
    </div>
  </header>
</template>

<script setup lang="ts">
import { HeadingDisplay, ChipContext } from '@warrenbrasil/nebraska-web';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { SectionError } from '@/modules/common/components/SectionError';

import { ITemplateHeaderData } from './types';

interface Props {
  isLoading?: boolean;
  hasError?: boolean;
  data: ITemplateHeaderData;
}

withDefaults(defineProps<Props>(), {
  hasError: false,
  isLoading: false
});

interface Emits {
  (e: 'on-retry'): void;
}
const emits = defineEmits<Emits>();

const emitOnRetry = () => {
  emits('on-retry');
};
</script>

<style lang="less" scoped>
.template-header {
  ::v-deep p,
  ::v-deep h1 {
    color: @element-over-image !important;
  }

  &__loader {
    width: 50%;
  }

  &__warning {
    max-width: 366px;
    margin-top: @size-spacing-x800;
    margin-bottom: @size-spacing-x500;
  }

  &__chip-context {
    background: @status-brand-background !important;
    padding: @size-spacing-x150 @size-spacing-x150;
    color: @status-brand !important;
    margin-bottom: @size-spacing-x400;

    :deep(.chip--icon) {
      margin-right: 0;
    }

    :deep(svg) {
      width: auto !important;
      height: 18px !important;
    }

    :deep(path) {
      fill: @status-brand;
    }
  }
}
</style>
